(function(window, app) {
  "use strict";

  app.router.add({
    "user/:username/theme(/)": [
      "themeSettings",
      {
        regexp: {
          username: /[\w\-]+/
        }
      }
    ]
  });

  app.router.add({
    "user/:username(/)(:section)(/)": [
      "userProfile",
      {
        regexp: {
          username: /[\w\-]+/,
          section: /about|following|followers|conversations|quests/
        }
      }
    ]
  });
})(window, window.app);
